// extracted by mini-css-extract-plugin
module.exports = {"panel":"ComplexTable_panel__EtXK8"};